import React from "react"
import Label from "@kit/design/label"
import Input from "@kit/design/input"
import { ColorInput } from "core/color-picker"
import { useBlocks } from "app/regions/hooks/use-blocks"
import { Padding } from "app/regions/blocks/section/utils/padding"
import { Margin } from "app/regions/blocks/section/utils/margin"
import { BlocksImageUploader } from "app/regions/blocks/shared/blocks-image-uploader"
import { Expander } from "app/regions/blocks/shared/expander"
import { BackgroundColor } from "../../components/background-color"
import { BorderSettings } from "../../components/border-settings"
import { FontSettings } from "../../../header/utils/font-settings"

export function RoundImageLeftCopyRightSettings({ block_id }) {
  const { properties, update } = useBlocks(block_id)

  return (
    <>
      <div className="mb-4">
        <BlocksImageUploader
          className="h-40"
          label="Image"
          name="image"
          image={properties.image}
          alt={properties.alt}
          update={file =>
            update({
              image: file.image || properties.image,
              alt: file.alt
            })
          }
          remove={() => update({ image: "", alt: "" })}
        />
      </div>

      <div className="mb-4">
        <Label htmlFor="imageUrl">Image URL</Label>
        <Input
          className="text-gray-700 mb-1 w-full"
          placeholder="https://example.com"
          name="imageUrl"
          onChange={e => update({ imageUrl: e.target.value })}
          value={properties.imageUrl || ""}
        />
      </div>

      <Expander label="Colors">
        <BackgroundColor properties={properties} update={update} />

        <div>
          <Label htmlFor="headingColor">Heading</Label>
          <ColorInput
            id="headingColor"
            name="headingColor"
            onChange={e => update({ headingColor: e.target.value })}
            value={properties.headingColor}
          />
        </div>

        <div>
          <Label htmlFor="textColor">Text</Label>
          <ColorInput
            id="textColor"
            name="textColor"
            onChange={e => update({ textColor: e.target.value })}
            value={properties.textColor}
          />
        </div>
      </Expander>

      <Expander label="Spacing">
        <div className="mb-4">
          <Padding properties={properties} update={update} />
        </div>
        <div className="mb-4">
          <Margin properties={properties} update={update} />
        </div>
      </Expander>

      <div>
        <Expander label="Fonts">
          <FontSettings
            label="Heading font"
            fontFamilySetting="headingFontFamily"
            fontWeightSetting="headingFontWeight"
            properties={properties}
            update={update}
          />

          <FontSettings
            label="Text font"
            fontFamilySetting="textFontFamily"
            fontWeightSetting="textFontWeight"
            properties={properties}
            update={update}
          />
        </Expander>
      </div>

      <BorderSettings properties={properties} update={update} />
    </>
  )
}
